import { calmTokens as t } from '../../shared/tokens';
import { fmtEUR } from '../../shared/format';
import { fmtRecurrenceShort } from '../../shared/recurrence';
import { IconArrowDown, IconArrowUp, IconCheck } from '../../shared/icons';

export default function ForecastSageTxCard({ tpl, done }) {
  const isDebit = tpl.type === 'debit';
  const title = tpl.title || tpl.description || 'Sans titre';
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '36px 1fr auto auto',
        alignItems: 'center',
        gap: 14,
        padding: '14px 20px',
        opacity: done ? 0.55 : 1,
      }}
      className="forecast-sage-tx"
    >
      <div
        style={{
          width: 36,
          height: 36,
          borderRadius: 10,
          background: isDebit ? t.debitDim : t.creditDim,
          border: `1px solid ${isDebit ? t.debitBorder : t.creditBorder}`,
          display: 'grid',
          placeItems: 'center',
          color: isDebit ? t.debit : t.credit,
        }}
      >
        {isDebit ? <IconArrowUp size={15} /> : <IconArrowDown size={15} />}
      </div>

      <div style={{ minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          <span
            style={{
              fontSize: 14,
              fontWeight: 500,
              letterSpacing: -0.15,
              color: done ? t.textMute : t.text,
              textDecoration: done ? 'line-through' : 'none',
              textDecorationColor: 'rgba(255,255,255,0.35)',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              minWidth: 0,
              fontFamily: t.fontUi,
            }}
          >
            {title}
          </span>
          {done && (
            <span
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                fontSize: 11,
                color: t.credit,
                fontWeight: 500,
                flexShrink: 0,
                fontFamily: t.fontUi,
              }}
            >
              <IconCheck size={11} />
              effectuée
            </span>
          )}
        </div>
        <div
          style={{
            fontSize: 11,
            color: t.textMute,
            marginTop: 3,
            display: 'flex',
            gap: 8,
            alignItems: 'center',
            fontFamily: t.fontUi,
          }}
        >
          <span>{fmtRecurrenceShort(tpl.recurrencePattern)}</span>
          <span style={{ opacity: 0.4 }}>·</span>
          <span style={{ fontFamily: t.fontMono }}>
            le {String(tpl.dayOfMonth || 1).padStart(2, '0')}
          </span>
        </div>
      </div>

      <div
        style={{
          fontFamily: t.fontMono,
          fontSize: 15,
          fontWeight: 500,
          color: isDebit ? t.debit : t.credit,
          letterSpacing: -0.3,
          textDecoration: done ? 'line-through' : 'none',
          textDecorationColor: 'rgba(255,255,255,0.35)',
          fontVariantNumeric: 'tabular-nums',
        }}
      >
        {isDebit ? '− ' : '+ '}
        {fmtEUR(tpl.amount)}
      </div>

      {!done ? (
        <span
          style={{
            padding: '4px 10px',
            borderRadius: 999,
            fontSize: 11,
            fontWeight: 500,
            background: 'rgba(255,255,255,0.04)',
            color: t.textMute,
            border: `1px solid ${t.border}`,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontFamily: t.fontUi,
            whiteSpace: 'nowrap',
          }}
        >
          À venir
        </span>
      ) : (
        <span aria-hidden="true" style={{ width: 0, height: 0 }} />
      )}
    </div>
  );
}
